export const removeUsernameFromUrlParams = (): void => {
  const params = new URLSearchParams(window.location.search);
  const username = params.get('username');
  if (!!username) {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    url.searchParams.delete('username');
    history.replaceState({}, document.title, url.toString());
  }
};
